// @flow
import * as React from "react"
import type { Plan } from "./types"
import passportImage from "./images/passport.png"
import perksImage from "./images/perks.png"
import flexImage from "./images/flex.png"
import SubscribePlan from "modals/SubscribePlan"
import featureFlags from "global/feature-flags"

const isPassportMainPlanToPromote = featureFlags.showPassportInHomepagePlans()

const flex = {
  title: "Flex",
  subtitle: "Pay as you go",
  alternativeSubtitle: "Pay as you go",
  description: "No fees, just fun. For you if you just want the right gear at the right time or want to try before you buy.",
  activeByDefault: false,
  monthlyPrice: 0,
  note: "",
  paragraphs: (detailed = false): React.Node[] => detailed
    ? [
      <span>Book anytime, worldwide.</span>,
      <span>Book multiple products at once</span>,
      <span>Free cancellation up to 48 hours before</span>,
    ]
    : [
      <span><strong>Multiple items</strong> at once</span>,
      <span><strong>6-month</strong> advanced pre-book</span>,
      <span><strong>48hr</strong> cancellation period</span>,
    ],
  subscribeButton: {
    primary: false,
    displayName: "Book now",
  },
  promotionalImage: flexImage,
  slug: "awayco_user_flex",
}

const perks = {
  title: "Perks",
  subtitle: "$20/mth for 25% off every booking",
  alternativeSubtitle: "Pay 20 get 25",
  description: "Experience the Awayco network with minimum commitment and maximum savings. For you if you get outside on weekends, or are planning a trip for a week or more.",
  activeByDefault: !isPassportMainPlanToPromote,
  monthlyPrice: 20,
  priceNote: "",
  note: "Everything in Flex, plus... ",
  upsellConditions: [
    "$20/mth subscription for 25% off every booking",
    "Cancel your subscription anytime",
  ],
  paragraphs: (detailed = false): React.Node[] => detailed
    ? [
      <span><strong>25% off</strong> all bookings, worldwide</span>,
      <span><strong>Book multiple items</strong> with your Perks discount for family and friends.</span>,
      <span><strong>Free 24-hour</strong> cancellation period</span>,
    ]
    : [
      <span>Unlimited items 25% off anywhere on Awayco</span>,
      <span>Save with friends and family on a single booking</span>,
      <span>Save money from 3rd booking day</span>,
      <span>Cancel your subscription anytime</span>,
    ],
  confirmationText: "Now you'll get 25% off all your bookings! Head to the checkout to see your savings. Happy shredding.",
  subscribeButton: {
    primary: false,
    displayName: "Try it",
    modalComponent: SubscribePlan,
  },
  promotionalImage: perksImage,
  slug: "awayco_user_perks",
}

const passport = {
  title: "Passport",
  subtitle: "One price, total freedom",
  alternativeSubtitle: "Total freedom",
  description: "Unlimited access to 10,000+ products from 200+ brands in +250 stores in 30+ countries. For you if you want an endless quiver, at home and on the road.",
  activeByDefault: isPassportMainPlanToPromote,
  monthlyPrice: 100,
  priceNote: "$20 off first 2 months",
  note: "Everything in Flex, plus... ",
  upsellPricingDescription: "$100/mnth, unlimited rentals. First mnth free.",
  paragraphs: (detailed = false): React.Node[] => detailed
    ? [
      <span><strong>Book anytime</strong>, worldwide.</span>,
      <span><strong>1 product</strong> at a time</span>,
      <span><strong>Free cancellation</strong> up to 24 hours before</span>,
      <span><strong>Unlimited days</strong> per month</span>,
      <span><strong>Unlimited categories</strong></span>,
      <span><strong>Unlimited destinations</strong></span>,
      <span><strong>Minimum 3 month</strong> commitment</span>,
    ]
    : [
      <span><strong>Unlimited days</strong></span>,
      <span><strong>Unlimited categories</strong></span>,
      <span><strong>Worldwide</strong></span>,
    ],
  subscribeButton: {
    primary: true,
    displayName: "Subscribe",
    modalComponent: SubscribePlan,
  },
  promotionalImage: passportImage,
  slug: "awayco_user_passport",
}

export const plans: Array<Plan> = isPassportMainPlanToPromote ? [passport, perks, flex] : [perks, flex];



// WEBPACK FOOTER //
// ./src/data/plans/constants.js